export default {
  inserted: function (el, binding, vnode) {
    const events = Object.keys(binding.modifiers)

    if (events.length === 0) {
      events.push('click')
    }

    events.forEach(event => {
      el.addEventListener(event, function () {
        let fn = binding.value
        if (!fn) {
          throw new Error('The value passed to v-ga is not defined')
        }

        fn.apply(vnode.context)
      })
    })
  }
}
